import "../../../styles/reset.css";
import "./ColorPicker.css"
import React from "react";


class ColorPicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        }
    }

    handleOnClick = (i) => {
        if (this.state.expanded) {
            this.setState({expanded: false});
        } else {
            this.setState({expanded: true});
        }
    };

    render() {
        let colors = ["blue", "violet", "cian"];

        let picker__items = colors.map((color) =>
            <div className={`color-picker__item color-picker__item_color_${color}`}
                 onClick={() => this.props.handleClickColor(color)}
                 onClickCapture={this.handleOnClick}/>
        );

        const modifier = (this.state.expanded) ? "selected" : `color_${this.props.color}`;
        return (
            <div className="color-picker">
                <div className={`color-picker__item color-picker__item_selected color-picker__item_${modifier}`}
                     onClick={this.handleOnClick}/>
                {this.state.expanded && <React.Fragment>{picker__items}</React.Fragment>}
            </div>
        );
    }
}

export default ColorPicker;
